import { useState, useRef, useCallback } from 'react';
import ReactPlayer from 'react-player';

export const useAudioPlayer = () => {
  const [isSeekBarVisible, setIsSeekBarVisible] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [playbackPosition, setPlaybackPosition] = useState(0);
  const playerRef = useRef<ReactPlayer | null>(null);

  const togglePlayPause = useCallback(() => {
    if (!isSeekBarVisible) {
      setIsSeekBarVisible(true);
    }
    setIsPlaying((prev) => !prev);
  }, [isSeekBarVisible]);

  const handleSeekChange = useCallback((event: Event, newValue: number | number[]) => {
    const newValueInRange = Array.isArray(newValue) ? newValue[0] : newValue;
    setPlaybackPosition(newValueInRange / 100);
    playerRef.current?.seekTo(newValueInRange / 100, 'fraction');
  }, []);

  const handleProgress = useCallback((state: { played: number }) => {
    setPlaybackPosition(state.played);
  }, []);

  const handleEnded = useCallback(() => {
    setIsPlaying(false);
  }, []);

  return {
    isSeekBarVisible,
    isPlaying,
    playbackPosition,
    togglePlayPause,
    handleSeekChange,
    handleProgress,
    handleEnded,
    playerRef,
  };
};
